export const APP_HOME_PATH = "/app";
export const COPILOT_HOME_PATH = "/app/inicio";
export const DASHBOARD_PATH = "/app/dashboard";

export const COPILOT_HOME_SWITCH_KEY = "enable_copilot_home";
export const COPILOT_HOME_SWITCH_BRAND = "flow";
export const COPILOT_HOME_BRANDS: readonly string[] = ["flow", "etb"];

export { RESERVATIONS_SETUP_PATH } from "@/lib/reservations-setup";
export const NEW_ASSISTANT_PATH = "/app/automations?nuevo=1";
export const CONNECT_CHANNEL_PATH = "/app/settings/channels";
export const NEW_CAMPAIGN_PATH = "/app/campaigns";
export const NEEDS_HUMAN_PATH = "/app/conversations?filter=needs_human";
export const TODAY_RESERVATIONS_PATH = "/app/reservations/confirmation";

export function isCopilotHomeSwitchOn(value: unknown): boolean {
  return typeof value === "string" && value.trim().toLowerCase() === "true";
}

export function copilotHomeAvailable(brandId: string): boolean {
  return COPILOT_HOME_BRANDS.includes(brandId);
}

export function landingPath(copilotHome: boolean, firstAllowedPath: string): string {
  return copilotHome ? COPILOT_HOME_PATH : firstAllowedPath;
}

export interface HomeNavVisibility {
  showInicio: boolean;
  showDashboard: boolean;
}

export function homeNavVisibility(copilotHome: boolean, canDashboard: boolean): HomeNavVisibility {
  return { showInicio: copilotHome, showDashboard: !copilotHome && canDashboard };
}
